import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  createEmbedVideoSocialPostCaptions,
  createSocialPostCaptions,
  createVideoSocialPostCaptions,
  creationRequestIdSelector,
  podcastEpisodeIdSelector,
  selectedSocialPostCaptionsConfigSelector,
  videoIdSelector,
} from 'redux/modules/download';
import { CreateSocialPostCaptions } from './types';

export type UseSocialPostCaptionsResult = {
  createSocialPostCaptions: CreateSocialPostCaptions;
};

export default function useSocialPostCaptions(): UseSocialPostCaptionsResult {
  const { hasSocialPostCaptions, source } = useSelector(
    selectedSocialPostCaptionsConfigSelector,
  );
  const videoId = useSelector(videoIdSelector);
  const episodeId = useSelector(podcastEpisodeIdSelector);
  const creationRequestId = useSelector(creationRequestIdSelector);

  const dispatch = useDispatch();

  const handleCreateSocialPostCaptions: CreateSocialPostCaptions = useCallback(
    args => {
      if (!hasSocialPostCaptions) {
        if (source === 'embed' && videoId) {
          dispatch(createEmbedVideoSocialPostCaptions({ videoId, ...args }));
        } else if (source === 'audio' && episodeId) {
          dispatch(createSocialPostCaptions(episodeId));
        } else if (source === 'video' && creationRequestId) {
          dispatch(createVideoSocialPostCaptions(creationRequestId));
        }
      } else if (source === 'embed' && videoId) {
        dispatch(
          createEmbedVideoSocialPostCaptions({
            ...args,
            videoId,
            isRegenerateRequest: true,
          }),
        );
      }
    },
    [
      creationRequestId,
      dispatch,
      episodeId,
      hasSocialPostCaptions,
      source,
      videoId,
    ],
  );

  return {
    createSocialPostCaptions: handleCreateSocialPostCaptions,
  };
}
